import { useContext } from "react";
import { Container, Card, Row, Col, Badge } from "react-bootstrap";
import { AuthContext } from "../../context/AuthContext";

const classes = require("./Perfil.module.css").default;

const Perfil = () => {
  const { usuario } = useContext(AuthContext);

  if (!usuario) {
    return <div>Cargando...</div>;
  }

  return (
    <Container className={classes.container}>
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className={classes.profileCard}>
            <Card.Header className={classes.cardHeader}>
              <h3>Perfil de Usuario</h3>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Nombre:</label>
                    <p>{usuario.nombre}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Apellido Paterno:</label>
                    <p>{usuario.apellido_paterno}</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Apellido Materno:</label>
                    <p>{usuario.apellido_materno || "No especificado"}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Correo:</label>
                    <p>{usuario.correo}</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Teléfono:</label>
                    <p>{usuario.telefono || "No especificado"}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Municipio:</label>
                    <p>{usuario.municipio || "No especificado"}</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Rol:</label>
                    <p>{usuario.rol?.nombre}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className={classes.infoGroup}>
                    <label>Estado:</label>
                    <Badge bg={usuario.estatus === 1 ? "success" : "danger"}>
                      {usuario.estatus === 1 ? "Activo" : "Inactivo"}
                    </Badge>
                  </div>
                </Col>
              </Row>
              {usuario.estado && (
                <Row>
                  <Col md={6}>
                    <div className={classes.infoGroup}>
                      <label>Estado:</label>
                      <p>{usuario.estado.nombre}</p>
                    </div>
                  </Col>
                </Row>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Perfil;
